import { http } from 'wix-vod-adapters';

export default http;



// WEBPACK FOOTER //
// ./src/shared/utils/http.js